export enum ThemeTypes {
  SWITCH_COLOR_MODE = '@theme/SWITCH_COLOR_MODE',
}

export interface ThemeState {
  readonly isDarkMode: boolean | null
}

export interface SwitchColorModePayload {
  isDarkMode: boolean
}
